import Component from "react-pure-render/component";
import React, { PropTypes } from "react";
import GalleryItem from "./galleryItem.react";
import MediasModal from "../components/mediasModal.react";
import Button from "../components/Button.react";
import { addNotificationsForInvalidFields } from "../lib/validationWeb";

export default class Gallery extends Component {
  static propTypes = {
    id: PropTypes.string
  };

  generateGalleryContent = () => {
    const {
      mediasResults,
      updateDataFromServerAction,
      galleryItems,
      gallery,
      apiHost,
      actions,
      isEditGalleryItemModalVisible,
      isRemoveGalleryItemModalVisible
    } = this.props;
    return gallery.get("items")
      ? gallery
          .get("items")
          .valueSeq()
          .map(function(galleryItem, index) {
            galleryItem = galleryItems.get(galleryItem.get("uid"));
            return (
              <div className="col-xs-3" key={index}>
                <GalleryItem
                  updateDataFromServerAction={updateDataFromServerAction}
                  item={galleryItem}
                  apiHost={apiHost}
                  wrapperWidth={100}
                  wrapperHeight={100}
                  actions={actions}
                  isEditModalVisible={isEditGalleryItemModalVisible}
                  isRemoveModalVisible={isRemoveGalleryItemModalVisible}
                />
              </div>
            );
          })
      : [];
  };

  openAddGalleryItemModal = () => {
    const { actions, gallery } = this.props;
    actions.setIsAddGalleryGalleryItemModalOpen(gallery.get("uid"));
  };

  closeAddGalleryItemModal = () => {
    const { actions } = this.props;
    actions.setIsAddGalleryGalleryItemModalOpen(false);
  };

  createGalleryGalleryItem = () => {
    const {
      actions,
      selectedMediaItem,
      notificationSystem,
      gallery,
      medias,
      updateDataFromServerAction
    } = this.props;
    const items = selectedMediaItem.toArray();
    items.forEach(function(item, index) {
      const data = {
        name: medias.getIn([item, "name"]),
        description: medias.getIn([item, "description"]),
        mediaUID: item
      };
      actions
        .createGalleryGalleryItem(data, gallery.get("uid"))
        .then(({ error, payload }) => {
          if (error) {
            addNotificationsForInvalidFields(payload, notificationSystem);
          } else if (index === items.length - 1) {
            updateDataFromServerAction();
          }
        });
    });
  };

  render() {
    const {
      createGalleryItemForm: { isAddModalVisible },
      gallery,
      notificationSystem,
      mediaCategoriesSearch,
      medias,
      mediaCategories,
      selectedMediaItem,
      actions,
      apiHost,
      meta,
      mediasResults
    } = this.props;
    const galleryItems = this.generateGalleryContent();

    return (
      <div className="row">
        {galleryItems}
        <Button
          onClick={this.openAddGalleryItemModal}
          className="info"
          text="Dodaj nowy element do galerii"
        />
        {isAddModalVisible === gallery.get("uid") && (
          <MediasModal
            closeModalAction={this.closeAddGalleryItemModal}
            mainAction={this.createGalleryGalleryItem}
            actions={actions}
            notificationSystem={notificationSystem}
            mediaCategoriesSearch={mediaCategoriesSearch}
            medias={medias}
            mediaCategories={mediaCategories}
            selectedMediaItem={selectedMediaItem}
            apiHost={apiHost}
            mediasResults={mediasResults}
            meta={meta}
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/galleries/gallery.react.js